import { Bomb, Cylinder, Droplets, Fish, Flame, FlameKindling, PersonStanding, Skull } from "lucide-react";

const GHS = {
  GHS01: [Bomb, "Explosive"], GHS02: [Flame, "Flammable"], GHS03: [FlameKindling, "Oxidising"], GHS04: [Cylinder, "Gas under pressure"],
  GHS05: [Droplets, "Corrosive"], GHS06: [Skull, "Toxic"], GHS07: [null, "Harmful / irritant"], GHS08: [PersonStanding, "Health hazard"], GHS09: [Fish, "Environment"],
};

export const GhsPictogram = ({ code, size = 40 }) => {
  const [Icon, label] = GHS[code] || [null, code];
  return (
    <span className="inline-flex flex-col items-center gap-1" title={label} data-testid={`ghs-${code}`}>
      <span className="flex rotate-45 items-center justify-center border-[3px] bg-white" style={{ width: size, height: size, borderColor: "#DC2626" }}>
        <span className="-rotate-45 text-black">{Icon ? <Icon style={{ width: size * 0.55, height: size * 0.55 }} /> : <b style={{ fontSize: size * 0.6 }}>!</b>}</span>
      </span>
      <span className="mt-1 text-[9px] font-semibold uppercase leading-tight">{label}</span>
    </span>
  );
};

const Block = ({ title, tone, children, testid }) => (
  <div className={`rounded-lg border-l-4 p-3 ${tone}`} data-testid={testid}>
    <p className="mb-1 text-xs font-bold uppercase tracking-wide">{title}</p>
    <div className="space-y-1 text-sm leading-relaxed">{children}</div>
  </div>
);

export const SdsDetail = ({ c }) => {
  const s = c.sds || {};
  const fa = s.first_aid || {};
  const t = { red: "border-red-500 bg-red-950/40", amber: "border-amber-500 bg-amber-950/30", blue: "border-cyan-500 bg-cyan-950/30", grey: "border-slate-500 bg-slate-900/60" };
  if (!c.sds) return <p className="text-sm opacity-70" data-testid="sds-no-summary">No emergency summary recorded for this product. Open the full SDS or ask your supervisor.</p>;
  return (
    <div className="space-y-3" data-testid={`sds-detail-${c.id}`}>
      <div className="flex flex-wrap items-end gap-5">
        {s.signal_word && <span className={`rounded px-2 py-1 text-sm font-black uppercase ${s.signal_word === "Danger" ? "bg-red-600 text-white" : "bg-amber-400 text-black"}`} data-testid="sds-signal-word">{s.signal_word}</span>}
        {(s.pictograms || []).map((p) => <GhsPictogram key={p} code={p} size={34} />)}
      </div>
      {!!(s.h_statements || []).length && <p className="text-xs opacity-80">{s.h_statements.join(" · ")}</p>}
      <Block title="First aid" tone={t.red} testid="sds-first-aid">
        {[["Eyes", fa.eyes], ["Skin", fa.skin], ["Breathed in", fa.inhalation], ["Swallowed", fa.ingestion]].filter(([, v]) => v).map(([k, v]) => <p key={k}><b>{k}:</b> {v}</p>)}
      </Block>
      <Block title="Spill - what to do" tone={t.amber} testid="sds-spill">
        <ol className="list-decimal space-y-0.5 pl-5">{(s.spill_response || []).map((x, i) => <li key={i}>{x}</li>)}</ol>
      </Block>
      <div className="grid gap-3 sm:grid-cols-2">
        <Block title="Fire" tone={t.grey} testid="sds-fire"><p>{s.fire_fighting}</p></Block>
        <Block title="PPE to wear" tone={t.blue} testid="sds-ppe"><p>{(s.ppe || []).join(", ")}</p></Block>
        <Block title="Storage" tone={t.grey} testid="sds-storage"><p>{c.storage_area}. {s.storage}</p>{!!(c.incompatibilities || []).length && <p><b>Keep away from:</b> {c.incompatibilities.join(", ")}</p>}</Block>
        <Block title="Product" tone={t.grey} testid="sds-product"><p>{c.chemical_name} · CAS {c.cas_number || "-"} · {c.un_number || "no UN number"}</p><p>{c.supplier}</p></Block>
      </div>
      {s.sample && <p className="text-[11px] italic opacity-70">Sample safety data sheet for demonstration - replace with the supplier's SDS.</p>}
    </div>
  );
};
